import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserModel } from '@models/user.model';
import { SearchCountryField, CountryISO } from '@capgo/ngx-intl-tel-input';
import { UsersFacadeService } from '@services/users/users-facade.service';
import { Subscription } from 'rxjs';
import { AppFacadeService } from '@services/app-facade.service';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'user-phone-number-form',
  templateUrl: './user-phone-number-form.component.html',
  styleUrls: ['./user-phone-number-form.component.sass']
})
export class UserPhoneNumberFormComponent implements OnInit, OnDestroy {
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.Canada, CountryISO.Australia, CountryISO.UnitedKingdom];
  userPhoneForm: FormGroup;
  _subs = new Subscription();
  loggedUser$ = this.appFacadeService.getLoggedUser$();
  loggedUser: UserModel;
  @Output()
  onSave = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private userFacade: UsersFacadeService,
    private appFacadeService: AppFacadeService,
    private messageToast: MessageService,
  ) { }

  ngOnInit(): void {
    this.userPhoneForm = this.fb.group({
      phoneNumber: ['', [
        Validators.required,
        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)
      ]],
      isEnableReviewText: []
    });

    this._subs.add(
      this.loggedUser$.subscribe(loggedUser => {
        this.loggedUser = loggedUser
        console.log(loggedUser);

        this.userPhoneForm.patchValue({
          phoneNumber: this.loggedUser.phoneNumber
        })
        this.userPhoneForm.patchValue({
          isEnableReviewText: this.loggedUser.isEnableReviewText
        })
      })
    );
  }
  onSaveNumber(form: FormGroup) {
    console.log("this.userPhoneForm.value.phoneNumber ", form.value.phoneNumber);
    this.userPhoneForm.value.phoneNumber = this.userPhoneForm.value.phoneNumber ? this.userPhoneForm.value.phoneNumber.internationalNumber : ''
    this.userFacade.saveUserPhoneNumber({
      userId: this.loggedUser.id,
      phoneNumber: this.userPhoneForm.value.phoneNumber,
      isEnableReviewText: true
    })
    this.onSave.emit()
  }
  handleEnableReviewTextChange(event: any) {
    if (event.checked == true && this.userPhoneForm.get("phoneNumber").invalid) {
      this.userPhoneForm.patchValue({
        isEnableReviewText: false,
      })
      this.messageToast.add({ severity: "error", summary: "Phone number", detail: "Invalid phone number", life: 3000 });
    } else {
      this.userPhoneForm.value.phoneNumber = this.userPhoneForm.value.phoneNumber ? this.userPhoneForm.value.phoneNumber.internationalNumber : ''
      this.userFacade.saveUserPhoneNumber({
        userId: this.loggedUser.id,
        phoneNumber: this.userPhoneForm.value.phoneNumber,
        isEnableReviewText: event.checked
      })
    }
  }
  ngOnDestroy(): void {
    if (this._subs) this._subs.unsubscribe()
  }

}
